import { axios } from "../../../lib"

export const addArticleRules = (expenseGroupId, articleIds) => 
{
    return axios.post('/nomenclatures/rules/article', {
        expenseGroupId,
        articleIds
    })
}